export default {
    product: {
        index: 'ProductTable',
        edit: 'ProductForm'
    },
    category: {
        index: 'CategoryIndex',
        edit: 'CategoryIndex',
        create: 'CategoryIndex'
    },
    source: {
        index: 'SourceTable',
        create: 'SourceForm',
        edit: 'SourceForm'
    },
    website: {
        index: "WebsiteTable",
        create: "WebsiteForm",
        edit: "WebsiteForm"
    },
    store: {
        index: "StoreTable",
        create: "StoreForm",
        edit: "StoreForm"
    },
    brand: {
        edit: "BrandForm"
    },
    pricelist: {
        index: "PricelistForm"
    },
    roles: {
        index: 'RolesTable',
        create: 'RolesForm',
        edit: 'RolesForm'
    },
    users: {
        index: 'UsersTable',
        create: 'UsersForm',
        edit: 'UsersForm'
    },
    attribute: {
        index: 'AttributeTable',
        create: 'AttributeForm',
        edit: 'AttributeForm'
    },
    destination: {
        index: 'DestinationTable',
        create: 'DestinationForm',
        edit: 'DestinationForm'
    },
    atelierCategory: {
        index: 'AtelierCategoryTree'
    },
}
